var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Works.CoauthorTagsView = function (superClass) {
  extend(CoauthorTagsView, superClass);
  function CoauthorTagsView() {
    return CoauthorTagsView.__super__.constructor.apply(this, arguments);
  }
  CoauthorTagsView.prototype.initialize = function (options) {
    if (options == null) {
      options = {};
    }
    _.defaults(options, {
      sortable: true
    });
    return CoauthorTagsView.__super__.initialize.apply(this, arguments);
  };
  CoauthorTagsView.prototype.viewForModel = function (model) {
    return new Works.CoauthorTagView(_({
      model: model
    }).extend(this.tagOptions));
  };
  return CoauthorTagsView;
}(Works.SuggestableTagsView);
window.extend = extend;
window.hasProp = hasProp;